import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "../../InputField";
import exportImage from "../../../asset/Images";
import { useQuery } from "react-query";
import axios from "axios";

export default function ProjectView() {
  const storedBranchArray =
    JSON.parse(sessionStorage.getItem("branchNames")) || [];
  const [selectBranch, setSelectedBranch] = useState(null);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();

  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // GET API START
  const projectData = async () => {
    return await axios.get(
      `${process.env.REACT_APP_HOST}/addprojects/all/${selectBranch}`
    );
  };

  const { data, isLoading, isError, refetch } = useQuery(
    ["projectData", selectBranch],
    projectData,
    {
      enabled: !!selectBranch,
      refetchOnWindowFocus: false,
    }
  );
  // GET API END

  let details = data && data?.data;

  const filteredDetails = searchTerm
    ? details?.filter((item) => {
        const nameMatch = item?.customerName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const statusMatch = item?.siteAddress
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        return nameMatch || statusMatch;
      })
    : details;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows =
    filteredDetails && filteredDetails?.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(
    filteredDetails && filteredDetails?.length / rowsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const overAllReportDetails = [
    {
      name: "OVERALL",
      value: "500",
      colorCode: "rgba(0, 184, 238, 0.3)",
      textColorCode: "rgba(0, 184, 238, 1)",
    },
    {
      name: "Completed",
      value: "19",
      colorCode: "rgba(1, 156, 80, 0.3)",
      textColorCode: "rgba(1, 156, 80, 1)",
    },
    {
      name: "Processing",
      value: "50",
      colorCode: "rgba(240, 145, 19, 0.3)",
      textColorCode: "rgba(240, 145, 19, 1)",
    },
    {
      name: "Cancelled",
      value: "500",
      colorCode: "rgba(237, 52, 54, 0.3)",
      textColorCode: "rgba(237, 52, 54, 1)",
    },
  ];

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">Project </div>
            <div
              className="header_Btn_container"
              onClick={() => {
                navigate("/project/projectAdd");
              }}
            >
              Add Project
            </div>
          </header>
          <section className="viewPageSectionContainer">
            <div className="reportMainContainer">
              {overAllReportDetails?.map((item, index) => {
                return (
                  <div className="overall-card">
                    <div className="overall-text">
                      <div
                        className="overall-label"
                        style={{ color: item.textColorCode }}
                      >
                        {item.name}
                      </div>
                      <div
                        className="overall-value"
                        style={{ color: item.textColorCode }}
                      >
                        {item.value}
                      </div>
                    </div>
                    <div
                      className="bg-shape1"
                      style={{ background: item.colorCode }}
                    ></div>
                    <div
                      className="bg-shape2"
                      style={{ background: item.colorCode }}
                    ></div>
                  </div>
                );
              })}
            </div>

            <div className="searchSelectMainContainer ">
              <div className="quotationInputSearch">
                <div className="searchInput">
                  <label className="searchInputLabel">Search</label>
                  <input
                    type="search"
                    className="searchInputCss"
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                    }}
                    placeholder="search by customer, site"
                  />
                </div>
              </div>
              <div className="quotationSelectSearch">
                <div className="selectContainer"></div>
                <div className="selectContainer">
                  <div className="searchInput">
                    <Controller
                      name="branchSelect"
                      control={control}
                      rules={{ required: "Branch selection is required" }}
                      render={({ field }) => (
                        <select
                          {...field}
                          className="searchSelectCss"
                          onChange={(e) => {
                            field.onChange(e); // Update form state
                            setSelectedBranch(e.target.value); // Update local state
                          }}
                          value={field.value || ""}
                        >
                          <option value="">-Select Branch-</option>
                          {storedBranchArray?.map((branch, index) => (
                            <option key={index} value={branch}>
                              {branch}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                    {errors.branchSelect && (
                      <p style={{ color: "red" }}>
                        {errors.branchSelect.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="tableMainContainer">
              <table className="tableMain">
                <thead>
                  <tr className="tableHeadRow">
                    <td className="tableHeaderTxt ">Project No</td>
                    <td className="tableHeaderTxt ">
                      Project for (Customer Name)
                    </td>
                    <td className="tableHeaderTxt ">Branch</td>
                    <td className="tableHeaderTxt ">Mobile No</td>
                    <td className="tableHeaderTxt ">Project Status</td>
                    <td
                      className="tableHeaderTxt "
                      style={{
                        width: "260px",
                      }}
                    >
                      Action
                    </td>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {false ? (
                    <>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="loader"></div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </>
                  ) : currentRows?.length > 0 ? (
                    currentRows &&
                    currentRows?.map((item, index) => {
                      return (
                        <tr>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.invoiceNo}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.customerName}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.siteName}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.mobileNo}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.status}
                          </td>
                          <td
                            className="tableDataTxt "
                            style={{
                              width: "260px",
                              height: "100%",
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                          >
                            <div className="d-flex gap-1 align-items-center">
                              <div className="actionBtn" onClick={() => {}}>
                                <img
                                  className="mb-1"
                                  src={exportImage?.editIcon}
                                  alt="editIcon"
                                />
                              </div>
                              <div className="actionBtn" onClick={() => {}}>
                                <img
                                  className="mb-1"
                                  src={exportImage?.deleteIcon}
                                  alt="deleteIcon"
                                />
                              </div>
                              <div className="actionBtn" onClick={() => {}}>
                                <img
                                  className="mb-1"
                                  src={exportImage?.duplicateIcon}
                                  alt="duplicateIcon"
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <p className="noDataFoundTxt">No Data Found</p>
                  )}
                </tbody>
              </table>
            </div>
          </section>
          <nav aria-label="Page navigation example" className="mt-2">
            <ul className="pagination justify-content-center">
              {/* Previous Button */}
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
              </li>

              {/* Page Numbers */}
              {Array?.from({ length: totalPages })?.map((_, index) => {
                const pageNumber = index + 1;
                const isActive = currentPage === pageNumber;

                return (
                  <li
                    key={pageNumber}
                    className={`page-item ${isActive ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}

              {/* Next Button */}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}
